import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import client from '../api/client';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import Button from '../components/ui/Button';
import Spinner from '../components/ui/Spinner';
import { Contenedor, TituloPagina, Subtitulo } from '../components/layout/Layout';

const Lista = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.lg};
  grid-template-columns: 1fr;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Clase = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.sm};

  h2 {
    font-size: 1.35rem;
    color: ${({ theme }) => theme.colors.sageDeep};
  }

  p {
    color: ${({ theme }) => theme.colors.textMuted};
    flex: 1;
  }
`;

const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.sm};
`;

function Clases() {
  const [tipos, setTipos] = useState(null);

  useEffect(() => {
    client.get('/tipos-clase').then(({ data }) => setTipos(data)).catch(() => setTipos([]));
  }, []);

  if (!tipos) return <Spinner />;

  return (
    <Contenedor>
      <TituloPagina>Clases</TituloPagina>
      <Subtitulo>
        Cuatro formas de practicar, un mismo método. Todas las clases son en grupos pequeños y con
        reserva previa.
      </Subtitulo>
      <Lista>
        {tipos.map((tipo) => (
          <Clase key={tipo.id}>
            <h2>{tipo.nombre}</h2>
            <Meta>
              {tipo.nivel && <Badge $tono="arena">{tipo.nivel}</Badge>}
              <Badge>{tipo.duracion_minutos} minutos</Badge>
            </Meta>
            <p>{tipo.descripcion}</p>
            <Button as={Link} to="/agenda" $variante="secundario" $chico>
              Ver horarios disponibles
            </Button>
          </Clase>
        ))}
      </Lista>
    </Contenedor>
  );
}

export default Clases;
